/**
 * @description This enumeration represents the event type for the employee service.
 * @enum
 * @export
 * @name EmployeeEventTypeEnum
 */
export enum EmployeeEventTypeEnum {

  // This enumeration value represents the event type for the employee service when a session is ended.
  SessionEnd,

  // This enumeration value represents the event type for the employee service when a session is expired.
  SessionExpired,

  // This enumeration value represents the event type for the employee service when a session is expiring soon.
  SessionExpiring,

  // This enumeration value represents the event type for the employee service when a session is started.
  SessionStart
}
